import { IDI_INSPECTION_SEARCH_START_LOADING, IDI_INSPECTION_SEARCH_END_LOADING, IDI_INSPECTION_SEARCH_LOADED, SET_IDI_INSPECTION_FILTER } from "../constants/IdiInspectionConstants";
import { IDI_INSPECTION_START_LOADING, IDI_INSPECTION_END_LOADING, IDI_INSPECTION_LOADED } from "../constants/IdiInspectionConstants";

import { getApiData, postApiJsonData, postApiFormData, downloadFile } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadIdiInspectionSearch(filters, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_INSPECTION_SEARCH_START_LOADING });

        try {

            var data = await postApiJsonData("IdiInspection/GetPaged", filters, null);
            
            if(data.success) {
                await dispatch({
                    type: IDI_INSPECTION_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: IDI_INSPECTION_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_INSPECTION_SEARCH_END_LOADING });
        }
    };
}

export function downloadIdiInspectionSearch(filters, documentName) {
    return async (dispatch) => {
            
        await dispatch({ type: IDI_INSPECTION_SEARCH_START_LOADING });

        try {

            var data = await downloadFile("IdiInspection/ExportToExcel", filters);
            
            if(data.success) {
                var url = window.URL.createObjectURL(data.file);
                var a = document.createElement('a');
                a.href = url;
                a.download = documentName;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();    
                a.remove();
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

            await dispatch({ type: IDI_INSPECTION_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_INSPECTION_SEARCH_END_LOADING });
        }
    };
}

export function setIdiInspectionFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_IDI_INSPECTION_FILTER,
            payload: filter
        });
    };
}

export function loadIdiInspection(id, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_INSPECTION_START_LOADING });

        try {

            var data = await getApiData("IdiInspection/GetIdiInspectionFBO", { id });
            
            if(data.success) {
                await dispatch({
                    type: IDI_INSPECTION_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                    dispatch(commonActions.setErrorMessage(data.errorDesc));
                }
                else if(data.errorCode == "402") {
                    if(data.companyId && data.companyId > 0) {
                        navigate('/invalid-company/idii/' + data.companyId + "/" + data.moduleName + "/" + id);
                    }
                    else {
                        navigate('/invalid-company');
                        dispatch(commonActions.setErrorMessage(data.errorDesc));
                    }
                }
                else {
                    dispatch(commonActions.setErrorMessage(data.errorDesc));
                }
            }
            
			await dispatch({ type: IDI_INSPECTION_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_INSPECTION_END_LOADING });
        }
    };
}

export function saveIdiInspection(fbo, status, message, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_INSPECTION_START_LOADING });

        try {

            var isAdd = fbo.isAddMode;
            var data = await postApiJsonData("IdiInspection/SaveIdiInspectionFBO", { status, message }, fbo);
            
            if(data.success) {
                if(isAdd) {
                    navigate('/idi-inspection-edit/' + data.responseEntities[0].idiInspection.id);
                    dispatch(commonActions.setSuccessMessage("IDI Inspection Created Successfully!"));
                }
                else {
                    await dispatch({
                        type: IDI_INSPECTION_LOADED,
                        payload: data.responseEntities[0]
                    });
                    
                    dispatch(commonActions.setSuccessMessage("IDI Inspection Saved Successfully!"));
                }
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }

			await dispatch({ type: IDI_INSPECTION_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_INSPECTION_END_LOADING });
        }
    };
}

export async function saveDocument(formData) {
    var documentData = {
        image: null
        , error: null
    };

    try {

        var data = await postApiFormData("IdiInspection/SaveInspectionImage", null, formData);

        if(data.success) {
            documentData.image = data.responseEntities[0];
        }
        else {
            documentData.error = data.errorDesc;
        }
    } 
    catch (error) {
        documentData.error = error;
    }
    
    return documentData;
}

export async function deleteDocument(idiInspectionImage) {
    var documentData = {
        image: null
        , error: null
    };

    try {

        var data = await postApiJsonData("IdiInspection/DeleteInspectionImage", null, idiInspectionImage);
        
        if(data.success) {
            documentData.image = data.responseEntities[0];
        }
        else {
            documentData.error = data.errorDesc;
        }
    } 
    catch (error) {
        documentData.error = error;
    }

    return documentData;
}

export async function generateDocument(idiInspectionId, documentType, approved) {
    var returnData = {
        success: false,
        errorMessage: "",
        successMessage: "IDI Inspection Document Generated Successfully!"
    };

    try {

        var data = await getApiData("IdiInspection/GenerateDocument", { idiInspectionId, documentType, approved });

        if(data.success) {
            returnData.success = true;
        }
        else {
            returnData.errorMessage = data.errorDesc;
        }
    } 
    catch (error) {
        returnData.errorMessage = error;
    }

    return returnData;
}

export function assignIdiInspection(idiInspectionId, userId, assignMe, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_INSPECTION_START_LOADING });

        try {

            var data = await postApiJsonData("IdiInspection/AssignIdiInspection", { idiInspectionId, userId, assignMe }, null);
            
            if(data.success) {
                dispatch(loadIdiInspection(idiInspectionId, navigate));
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
            await dispatch({ type: IDI_INSPECTION_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_INSPECTION_END_LOADING });
        }
    };
}